<template>
  <div class="container-fluid py-4 role-medical-page">

    <!-- ================= HEADER ================= -->
    <div class="page-header-medical d-flex justify-content-between align-items-center flex-wrap mb-4">

      <div class="title-block">
        <div class="icon-box">
          <i class="bi bi-shield-lock"></i>
        </div>

        <div>
          <h2 class="title">
            Gestion des Accès Système Médical
          </h2>

          <p class="subtitle">
            Paramétrage des rôles et permissions du stock médical
          </p>
        </div>
      </div>

      <button
        v-if="$store.getters.hasPermission('ROLE_CREATE')"
        class="btn btn-primary-medical"
        @click="creation"
      >
        <i class="bi bi-plus-circle me-2"></i>
        Nouveau profil
      </button>

    </div>

    <!-- ================= FILTRES ================= -->
    <div class="card medical-card p-3 mb-4">

      <div class="row g-3 align-items-end">

        <div class="col-12 col-md-4">
          <label class="form-label">Rechercher</label>
          <input
            type="text"
            v-model="searchQuery"
            class="form-control form-control-medical"
            placeholder="Nom du profil médical..."
          />
        </div>

        <div class="col-6 col-md-2">
          <label class="form-label">Items</label>
          <select v-model="itemsperpage" class="form-select form-control-medical">
            <option v-for="item in itemsPerPageT" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>

        <div class="col-6 col-md-3">
          <label class="form-label">Trier par</label>
          <select v-model="orderBy" class="form-select form-control-medical">
            <option v-for="(value, key) in orderByTabs" :key="key" :value="value">
              {{ key }}
            </option>
          </select>
        </div>

        <div class="col-6 col-md-3">
          <label class="form-label">Ordre</label>
          <select v-model="sortOrder" class="form-select form-control-medical">
            <option v-for="(value, key) in sortOrders" :key="key" :value="value">
              {{ key }}
            </option>
          </select>
        </div>

      </div>

    </div>

    <!-- ================= LOADING ================= -->
    <div v-if="isLoading" class="loading-box">
      <div class="spinner-border text-primary"></div>
      <p class="mt-3">Chargement des profils d’accès...</p>
    </div>

    <!-- ================= TABLE ================= -->
    <div v-else class="card medical-card">

      <div class="table-responsive">

        <table class="table table-hover align-middle text-center mb-0">

          <thead class="table-medical">
            <tr>
              <th>#</th>
              <th>Profil</th>
              <th>Statut</th>
              <th>Actions</th>
            </tr>
          </thead>

          <tbody>

            <tr v-for="(type, index) in paginatedTypeUsers" :key="type.id">

              <td>
                {{ index + 1 + (currentPage - 1) * itemsperpage }}
              </td>

              <td class="text-start fw-semibold">
                {{ type.nom }}
              </td>

              <td>
                <span :class="type.isEnabled ? 'badge badge-success' : 'badge badge-secondary'">
                  {{ type.isEnabled ? 'Actif' : 'Inactif' }}
                </span>
              </td>

              <td>
                <div class="dropdown">
                  <button class="btn btn-light btn-sm" data-bs-toggle="dropdown">
                    Actions
                  </button>

                  <ul class="dropdown-menu dropdown-menu-end">

                    <li v-if="$store.getters.hasPermission('ROLE_UPDATE')">
                      <a class="dropdown-item" @click="modifier(type.id)">
                        Modifier
                      </a>
                    </li>

                    <li v-if="$store.getters.hasPermission('ROLE_DELETE')">
                      <a class="dropdown-item text-danger" @click="supprimer(type.id)">
                        Supprimer
                      </a>
                    </li>

                  </ul>
                </div>
              </td>

            </tr>

            <tr v-if="paginatedTypeUsers.length === 0">
              <td colspan="4" class="py-4">
                Aucun profil d’accès trouvé
              </td>
            </tr>

          </tbody>

        </table>

      </div>

      <!-- ================= PAGINATION ================= -->
      <div class="p-3 d-flex justify-content-end">

        <ul class="pagination pagination-medical mb-0">

          <li class="page-item" :class="{ disabled: currentPage === 1 }">
            <button class="page-link" @click="changePage(currentPage - 1)">
              Précédent
            </button>
          </li>

          <li
            v-for="page in totalPages"
            :key="page"
            class="page-item"
            :class="{ active: page === currentPage }"
          >
            <button class="page-link" @click="changePage(page)">
              {{ page }}
            </button>
          </li>

          <li class="page-item" :class="{ disabled: currentPage === totalPages }">
            <button class="page-link" @click="changePage(currentPage + 1)">
              Suivant
            </button>
          </li>

        </ul>

      </div>

    </div>

  </div>
</template>

<script>
import api from '@/api'

export default {
  data() {
    return {
      isLoading: true,

      searchQuery: '',
      itemsperpage: 10,
      orderBy: 'nom',
      sortOrder: 'asc',

      typeUsers: [],
      currentPage: 1,

      itemsPerPageT: [10, 20, 50],

      orderByTabs: {
        Nom: 'nom',
        Création: 'createdAt',
        Modification: 'updatedAt'
      },

      sortOrders: {
        Croissant: 'asc',
        Décroissant: 'desc'
      }
    }
  },

  computed: {

    processedData() {
      let data = [...this.typeUsers]

      if (this.searchQuery) {
        const q = this.searchQuery.toLowerCase()
        data = data.filter(t =>
          (t.nom || '').toLowerCase().includes(q)
        )
      }

      data.sort((a, b) => {

        let valA = a[this.orderBy]
        let valB = b[this.orderBy]

        if (this.orderBy.includes('createdAt') || this.orderBy.includes('updatedAt')) {
          valA = new Date(valA)
          valB = new Date(valB)
        }

        if (valA < valB) return this.sortOrder === 'asc' ? -1 : 1
        if (valA > valB) return this.sortOrder === 'asc' ? 1 : -1
        return 0
      })

      return data
    },

    paginatedTypeUsers() {
      const start = (this.currentPage - 1) * this.itemsperpage
      return this.processedData.slice(start, start + this.itemsperpage)
    },

    totalPages() {
      return Math.ceil(this.processedData.length / this.itemsperpage) || 1
    }

  },

  methods: {

    creation() {
       console.log('CLICK OK')
  this.$router.push({ name: 'create_type_users' })
    },

    modifier(id) {
      this.$router.push({ name: 'edit_type_users', params: { id } })
    },

    async getTypeUsers() {
      this.isLoading = true
      try {
        const res = await api.getItems('type_users')
        this.typeUsers = res.data.data
      } finally {
        this.isLoading = false
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
      }
    },

    async supprimer(id) {
      if (!confirm("Voulez-vous supprimer ce profil d’accès ?")) return
      await api.deleteItem('type_users', id)
      this.getTypeUsers()
    }

  },

  watch: {
    searchQuery() { this.currentPage = 1 },
    itemsperpage() { this.currentPage = 1 },
    orderBy() { this.currentPage = 1 },
    sortOrder() { this.currentPage = 1 }
  },

  created() {
    this.getTypeUsers()
  }
}
</script>

<style scoped>

/* ================= PAGE ================= */
.role-medical-page {
  background: #f4f7fb;
  min-height: 100vh;
}

/* HEADER */
.page-header-medical {
  background: linear-gradient(135deg, #0f4c81, #071a2e);
  padding: 20px;
  border-radius: 18px;
  color: white;
}

/* TITLE */
.title-block {
  display: flex;
  gap: 15px;
  align-items: center;
}

.icon-box {
  width: 55px;
  height: 55px;
  border-radius: 14px;
  background: rgba(255,255,255,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
}

/* CARD */
.medical-card {
  border: none;
  border-radius: 18px;
}

/* INPUT */
.form-control-medical {
  border-radius: 10px;
  border: 1px solid #dbe3ee;
}

/* TABLE */
.table-medical {
  background: #0f4c81;
  color: white;
}

/* BADGE */
.badge-success {
  background: #00c853;
}

.badge-secondary {
  background: #64748b;
}

/* PAGINATION */
.pagination-medical .page-item.active .page-link {
  background: #0f4c81;
  border: none;
  color: white;
}

.pagination-medical .page-link {
  border-radius: 10px;
}

/* LOADING */
.loading-box {
  text-align: center;
  padding: 60px;
}

</style>